const url = require('./dev.uri').BASE_URI;

module.exports = {
  [url]: {
    // target:'https://beijing.tpr.ndlink.cn',
    // target:'https://baoji.tpr.ndlink.cn',
    // target:'https://ordos.tpr.ndlink.cn',
    target:'https://changsha.tpr.ndlink.cn',
    // target:'https://hlj.tpr.ndlink.cn',
    // target:'https://zhsq.tpr.ndlink.cn',
    // target:'https://gxsg.tpr.ndlink.cn',

    // target:'https://tianyun.tpr.ndlink.cn',
    // target:'https://bjsmxx.tpr.ndlink.cn',
    // target:'https://qinghai.tpr.ndlink.cn',
    // target:'https://cdsyjy.tpr.ndlink.cn',
    // target:'https://tangshan.tpr.ndlink.cn',
    // target:'https://bvclss.tpr.ndlink.cn',
    // target:'https://ningxia.tpr.ndlink.cn',
    // target:'https://taian.tpr.ndlink.cn',
    // target:'https://chinaswa.tpr.ndlink.cn',
    // target:'https://jlnu.tpr.ndlink.cn',
    // target:'https://mjuedu.tpr.ndlink.cn',

    // target:'http://localhost:48080',
    changeOrigin: true,
      pathRewrite: {
  ['^' + url]: ''
}
}
}



//////////////////
// WEBPACK FOOTER
// ./config/proxy-mock.js
// module id = J+A6
// module chunks = 276